import React from 'react';
import { CommonPageStep } from '..';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { MobileView } from './mobile/Entry.mobile';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';
import { Login } from '../login';

export const Entry = (): JSX.Element => {
  // Redux Hooks
  const pageStep = useAppSelector(selectAppPageStep);

  React.useEffect(() => {
    if (isMobileOnly) {
      outsideComponentDispatch(setAppPageStep(CommonPageStep.ENTRY));
    } else {
      outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
    }
  }, []);

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <Navigate to="/Login" />}
      {pageStep === CommonPageStep.LOGIN ? <Navigate to="/Login" /> : null}
      {pageStep === CommonPageStep.SIGNUP ? <Navigate to="/Signup" /> : null}
    </React.Fragment>
  );
};
